import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RestDataService} from '../../../services/rest-data.service';
import {SmallSelectItem} from '../../../services/common-datatypes';
import {RequiredInput} from '../../../decorators/common.decorators';
import {marker as _} from '@biesbjerg/ngx-translate-extract-marker';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-device-status-select',
    templateUrl: './device-status-select.component.html',
    styleUrls: ['./device-status-select.component.scss']
})
export class DeviceStatusSelectComponent implements OnInit {

    public selectList: SmallSelectItem[] = [];
    @Input() inline = false;
    @Input() autoOpen = false;
    @Input() multiple = false;
    @Input() @RequiredInput selectedItems!: SmallSelectItem[];
    @Output() selectedItemsChange = new EventEmitter<SmallSelectItem[]>();

    constructor(private translate: TranslateService,
                private dataService: RestDataService) {
        _('select.device_status.name');
        _('select.device_status.all');
    }

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        if (0 === this.selectList.length) {
            this.dataService.getDeviceStatus().then((data: SmallSelectItem[]) => {
                if (data && (0 < data.length)) {
                    data.forEach((item) => {
                        const newItem = new SmallSelectItem();
                        newItem.updateFromJson(item);
                        this.translate.get('device_status.' + item.name).subscribe(
                            (trans: string) => newItem.name = trans
                        );
                        this.selectList.push(newItem);
                    });
                }
            });
        }
    }

    updateData() {
        this.selectedItemsChange.emit(this.selectedItems);
    }
}
